import React, { useMemo } from "react";
import { IState } from "../../../../common/state/IState";
import { useSelector } from "react-redux";
import { ErrorMarkIconComponent } from "../../../../common/icons/ErrorMarkIconComponent";
import { IUserSubscriptionsUpdateErrorItem } from "../subscriptionPreferences/SubscriptionPreferencesModel";

const buildSelector = key => {
    key = "subscription_" + key;
    return (state: IState) => {
        const updateErrors =
            state?.userManagement?.subscriptionPreferences?.updateErrors;
        return (updateErrors
            ? updateErrors[key]
            : null) as IUserSubscriptionsUpdateErrorItem;
    };
};

const messagesMap = {
    exception: "Unsaved consents. Please try again later.",
    serverError: "Unsaved consents. Please try again later.",
    externalError: "Unsaved consents. Contact us to resolve this issue.",
};

export function SubscriptionsTableErrorElement({
    path,
    index,
    consentsTypesKeys,
    className,
}) {
    const style = useMemo(
        () => ({
            gridRow: 2 * index + 2,
            gridColumn: `1 / span ${consentsTypesKeys.length + 1}`,
        }),
        [index, consentsTypesKeys]
    );
    const errorSelector = useMemo(() => buildSelector(path), [path]);
    const error = useSelector(errorSelector);

    return (
        <div style={style} className={className} data-key={path}>
            {error && (
                <>
                    <ErrorMarkIconComponent />
                    {messagesMap[error.type]}
                </>
            )}
        </div>
    );
}